// extracted by mini-css-extract-plugin
export default {"instructors":"Instructors_instructors__NXIpZ","instructors__title":"Instructors_instructors__title__KXq+4","instructors__content":"Instructors_instructors__content__5KcaB"};